var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		{ active: _vm.activeMember.userId == _vm.member.userId },
		'chat-group-member',
	],style:({ height: _vm.height + 'px' })},[_c('div',{staticClass:"member-avatar"},[_c('el-image',{staticClass:"avatar",attrs:{"fit":"cover","src":_vm.member.userAvatar}})],1),_c('div',{staticClass:"member-name",style:({ 'line-height': _vm.height + 'px' })},[_c('div',[_vm._v(_vm._s(_vm.member.userName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }